import type {
    StyleRule} from '@archipro-design/aria';
import {
    projectTileSlotClassNames,
} from '@archipro-design/aria';
import {
    professionalTileClassName,
    professionalTileSlotClassNames,
    pxToRem,
} from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';

export const RecentlyViewedWrapper: StyleRule<{
    sectionTopMargin?: string;
}> = ({ theme, sectionTopMargin }) => {
    return {
        marginTop: sectionTopMargin,
        padding: pxArrayToRem([0, 0, 50, 0]),
        [theme.screen.laptop]: {
            marginTop: 0,
            padding: pxArrayToRem([120, 40, 80]),
        },
    };
};

export const RecentlyViewedSliderWrapper: StyleRule<{
    hasLeftPadding?: boolean;
    slideSize?: number;
}> = ({ theme, hasLeftPadding, slideSize }) => {
    return {
        width: '100%',
        height: '100%',
        whiteSpace: 'nowrap',
        overflowX: 'hidden',
        [`& .swiper-slide:last-of-type`]: {
            ...(hasLeftPadding && { marginRight: pxToRem(18) }),
            ...(!hasLeftPadding && { marginRight: pxToRem(30) }),
        },
        [`& .swiper-slide-prev`]: {
            ...(!hasLeftPadding && { marginLeft: pxToRem(36) }),
        },
        [`& .swiper`]: {
            ...(hasLeftPadding && { paddingLeft: pxToRem(18) }),
        },
        '& .swiper-slide': {
            ...(slideSize ? { width: pxToRem(slideSize) } : {}),
        },
        [theme.screen.laptop]: {
            [`& .swiper-slide:last-of-type`]: {
                marginLeft: 0,
            },

            [`& .swiper`]: {
                paddingLeft: 0,
            },

            '& .swiper-slide': {
                padding: pxToRem(10),
            },

            whiteSpace: 'nowrap',
            overflow: 'hidden',
            padding: 0,
        },
    };
};

export const RecentlyViewedSlider: StyleRule<{ slideSize?: number }> = ({
    theme,
    slideSize,
}) => {
    return {
        display: 'inline-flex',
        whiteSpace: 'normal',
        ...(slideSize ? { width: pxToRem(slideSize) } : {}),
        [theme.screen.laptop]: {
            width: 'auto',
        },
    };
};

export const RecentlyViewedText: StyleRule<{
    titleBottomSpacingMobile?: string;
}> = ({ theme, titleBottomSpacingMobile }) => {
    // Use <p> element and styles instead of H1 for SEO purposes
    return {
        padding: pxArrayToRem([0, 18]),
        fontSize: pxToRem(18),
        lineHeight: '100%',
        marginBottom: titleBottomSpacingMobile,
        width: '100%',
        textTransform: 'uppercase',
        ...theme.siteVariables.textStyles.Heading.Medium65,
        letterSpacing: theme.siteVariables.letterSpacingMedium,
        [theme.screen.laptop]: {
            ...theme.siteVariables.textStyles.Text.Roman55,
            lineHeight: '110%',
            fontSize: pxToRem(22),
            marginLeft: pxToRem(924),
            padding: pxArrayToRem([0, 0, 60, 0]),
            marginBottom: 0,
            whiteSpace: 'pre-line',
            textAlign: 'left',
            width: 'fit-content',
            letterSpacing: theme.siteVariables.letterSpacingSmall,
        },
    };
};

export const RecentlyViewedSliderControls: StyleRule = ({ theme }) => {
    return {
        display: 'none',
        [theme.screen.laptop]: {
            display: 'block',
            margin: pxArrayToRem([28, 10, 92, 0]),
            textAlign: 'right',
        },
    };
};

export const RecentlyViewedProjectTile: StyleRule = ({ theme }) => ({
    [`& .${projectTileSlotClassNames.contentTile}`]: {
        padding: pxArrayToRem([0, 18]),

        [theme.screen.laptop]: {
            padding: 0,
        },
    },
});

export const RecentlyViewedProfessionalTile: StyleRule = () => ({
    [`&.${professionalTileClassName}`]: {
        [`& .${professionalTileSlotClassNames.content}`]: {
            [`& .${professionalTileSlotClassNames.textWrap}`]: {
                width: '100%',
                paddingRight: pxToRem(12),

                [`& .${professionalTileSlotClassNames.title}`]: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                },

                [`& .${professionalTileSlotClassNames.category}`]: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                },
            },
        },
    },
});
